export default !!(('ontouchstart' in window) || (window.DocumentTouch && document instanceof window.DocumentTouch))



// WEBPACK FOOTER //
// ./node_modules/nespresso-library/src/utils/isTouch.js